import { Component, Input } from '@angular/core';
import {FormsModule} from '@angular/forms';
import { dashboard_messages } from '../../../providers/static-data';
import { CommonModule, DatePipe } from '@angular/common';

type selectOpt = 'video-content' | 'flashcard' | 'all-tests';

@Component({
  selector: 'app-top-student-card',
  standalone: true,
  imports: [FormsModule,CommonModule ],
  templateUrl: './top-student-card.component.html',
  styleUrl: './top-student-card.component.scss',
  providers: [DatePipe]
})
export class TopStudentCardComponent {
    @Input() filter: boolean = false;
  
    selectedOption : selectOpt = 'video-content';
  
    messages = dashboard_messages

}
